import { render, staticRenderFns } from "./ProSelect.vue?vue&type=template&id=35704989&"
import script from "./ProSelect.vue?vue&type=script&lang=js&"
export * from "./ProSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports